// @ts-nocheck
import { getEncryptedText } from "@/services/helperFunctions";
import React, { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { EXIST_LOCAL_STORAGE } from "../../services/constants";
// import { getEncryptedText, getStorage, getUrlParams } from "../../services/helperFunctions";

interface BondAnalytics {
    bondID?: any;
    getBondAnalytics?: any;
    initialBondsAnalyticsDetail?: any;
}

const BondAnalytics: React.FC<BondAnalytics> = ({ getBondAnalytics, bondID, initialBondsAnalyticsDetail }: any) => {
    // const { bondID } = useParams<{ bondID: string }>();
    // const key = getUrlParams('key');
    const bondAnalyticsData = initialBondsAnalyticsDetail?.[0];
    // const [bondAnalyticsData, setBondAnalyticsData] = useState<BondAnalytics | null>(null);
    // const isSeoPage = false
    // const [isloading, setIsloading] = useState(!isSeoPage);
    // const UserId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
    // const isLoggedIn = true;
    // const fetchBondData = async () => {
    //     try {
    //         const body = {
    //             params: {
    //                 isin: getEncryptedText(bondID),
    //             },
    //         };
    //         setIsloading(true)
    //         getBondAnalytics(body).then((res: any) => {
    //             setBondAnalyticsData(res.data[0]);
    //             setIsloading(false)
    //         }).catch((err: any) => {
    //             console.error("Error fetching bond data:", err);
    //             setIsloading(false)
    //         })
    //     } catch (error) {
    //         console.error("Error fetching bond data:", error);
    //     }
    // };
    // useEffect(() => {
    //     if (isLoggedIn && !isSeoPage) {
    //         fetchBondData();
    //     } else {
    //         setIsloading(false)
    //     }
    // }, [bondID]);
    return (
        <section className="">
            <h2 className="text fw-bold" style={{ fontSize: "15px" }}>Analytics</h2>
                <div className="bg-white card-group col-auto d-flex flex-lg-row flex-column align-items-stretch">
                    <div className="bd-card card col border-light">
                        <div className="card-body" >
                            <label className="card-subtitle mb-2 " style={{ color: '#294672', fontSize: "12px", fontWeight: "700", textWrap: 'balance' }}>Mod. Duration</label>
                            <div className={`card-title '}`}>
                                {bondAnalyticsData?.mod_duration ? bondAnalyticsData?.mod_duration?.toFixed(3) : '-'}
                            </div>
                        </div>
                    </div>
                    <div className="bd-card card col border-light">
                        <div className="card-body">
                            <label className="card-subtitle mb-2" style={{ color: '#294672', fontSize: "12px", fontWeight: "700", textWrap: 'balance' }}>Mac. Duration</label>
                            <div className={`card-title '}`} >{bondAnalyticsData?.mac_duration ? bondAnalyticsData?.mac_duration?.toFixed(3) : '-'}</div>
                        </div>
                    </div>
                </div>
                <div className="card-group d-flex align-items-stretch">
                    <div className="bd-card card col border-light" style={{ width: "18rem" }}>
                        <div className="card-body">
                            <label className="card-subtitle mb-2" style={{ color: '#294672', fontSize: "12px", fontWeight: "700" }}>Convexity</label>
                            <div className={`card-title '}`} >{bondAnalyticsData?.convexity ? bondAnalyticsData?.convexity?.toFixed(3) : '-'}</div>
                        </div>
                    </div>
                    <div className="bd-card card col border-light" style={{ width: "18rem" }}>
                        <div className="card-body" >
                        </div>
                    </div>
                </div>
        </section>
    )
}

export default memo(BondAnalytics);